<template>
  <select v-model="selected" @change="changeFilter">
      <option v-for="(option, optionIndex) in filterItem.filter_item_list"
              :key="'filter_item_' + optionIndex" :value="option.api_parameters" :data-adult="option.adult">
          {{option.title}}
      </option>
  </select>
</template>

<script>
import fp from 'lodash/fp'
import _ from 'lodash'
import { parse } from 'query-string'
import queryString from '@/common/utils/querystring'

export default {
  name: 'FilterItem',
  props: {
    filterItem: {
      type: Object
    },
    selectedItems: {
      type: Object
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    getCurrentAdultFlag () {
      return fp.flow(
        fp.getOr([], 'filter_item_list'),
        fp.filter(option => option.api_parameters === this.selected),
        fp.first,
        fp.getOr('n', 'adult')
      )(this.filterItem)
    },
    changeFilter () {
      const url = fp.flow(
        fp.getOr({}, 'query'),
        fp.thru(query => {
          return _.assign({}, query, parse(this.selected))
        }),
        fp.set('page', '1'),
        fp.set('adult', this.getCurrentAdultFlag()),
        queryString.relativeUrlBuilder
      )(this.$route)
      try {
        this.$router.push(url)
      } catch (e) { }
    },
    setSelected () {
      const getSelectedItem = fp.flow(
        fp.get(['filter_item_list', '0', 'api_parameters']),
        fp.thru(firstItem => parse(firstItem)),
        fp.keys,
        fp.first,
        fp.thru(key => `&${key}=${this.selectedItems[key]}`)
      )
      this.selected = getSelectedItem(this.filterItem)
    }
  },
  created () {
    this.setSelected()
  }
}
</script>
